import { useContext } from 'react';
import DocumentTemplateCategoryContext from '../context/DocumentTemplateCategoryContext';

const useDocumentTemplateCategoryContext = () => {
  return useContext(DocumentTemplateCategoryContext);
};

export default useDocumentTemplateCategoryContext;
